export default {"src":"/_next/static/media/tune.99e8b161.svg","height":24,"width":24};